<div class="form-container"
     [formGroup]="form">
    <div class="title"
      *ngIf="!preventInfoTitle && !imageUploadIds?.includes(imageUploadId.LARGE) && !imageUploadIds?.includes(imageUploadId.SMALL)"
      [ngClass]="{'mat-error': form.invalid}">
      {{ (imageUploadIds?.includes(imageUploadId.LOGO) ? 'catalog.common.brandLogo' : 'catalog.common.menuImage') | translate }}
    </div>
    <div class="image-upload-content">
      <ng-container *ngIf="selectedImage">
          <txp-type-selector class="category-selector"
                             [columns]="1"
                             [selected]="selectedImage"
                             [types]="imageTypes"
                             (select)="onSelectImageType($event)">
          </txp-type-selector>

        <div class="image-selection-container" [hidden]="isResizing" *ngIf="(!isBaseImageConfigurationFinished() && !isBaseImageConfigurationStarted()) || selectedImage.id !== imageUploadId.BASE_IMAGE">
          <ng-container *ngFor="let item of form.controls | keyvalue">
            <txp-change-set-notice
              [activeVersion]="selectedVersion"
              [hidden]="item.key !== selectedImage.id"
              [itemChanges]="itemChanges"
              [customDecider]="hasImageChanged.bind(this, item.value, item.key)"
              [noticeAlign]="'top'"
              [noticeType]="'icon'"
              [eventDetail]="'decorators.' + item.key + '.images'">
              <txp-file-upload [hidden]="item.key !== selectedImage.id"
                               [formControl]="$any(item.value)"
                               data-qa-label="ImageFileUpload"
                               [accept]="selectedImage.allowedMimeTypes"
                               [label]="'catalog.common.uploadAFile' | translate "
                               [showCrop]="true && (isReadOnly$ | async) === false"
                               [showRemove]="(isReadOnly$ | async) === false"
                               [autoResizeChannelId]="form.get(selectedImage.id).errors && form.get(selectedImage.id).errors['imageDimensions'] ? selectedImage.id : undefined"
                               (setIsResizing)="updateIsResizing($event)"
                               [disableFileUpload]="(isReadOnly$ | async) === true">
              </txp-file-upload>
            </txp-change-set-notice>
          </ng-container>

          <div class="instructions">
            <div *ngFor="let item of selectedImage.instructions | keyvalue"
                 [ngClass]="{'mat-error': form.get(selectedImage.id).errors &&
                 form.get(selectedImage.id).errors[item.key]}"
                 [innerHtml]="item.value | translate">
            </div>

            <div class="image-error mat-error"
                 *ngIf="form.get(selectedImage.id).errors">
              <span *ngIf="form.get(selectedImage.id).errors.fileSize">
                  {{ 'catalog.common.invalidFileSize' | translate }}
              </span>
              <span *ngIf="form.get(selectedImage.id).errors.fileType">
                  {{ 'catalog.common.invalidFileType' | translate }}
              </span>
              <span *ngIf="form.get(selectedImage.id).errors.imageDimensions">
                  {{ 'catalog.common.invalidImageDimensions' | translate }}
              </span>
              <span *ngIf="form.get(selectedImage.id).errors.imageAspectRatio">
                {{ 'catalog.common.invalidImageAspectRatio' | translate }}
              </span>
            </div>
          </div>
        </div>

        <div class="base-image-channels-selection"
             *ngIf="!isBaseImageConfigurationFinished()
              && !isBaseImageConfigurationStarted()
              && selectedImage
              && selectedImage.id === imageUploadId.BASE_IMAGE && form.get(selectedImage.id).value">
          <div class="channels" *ngIf="(validationPending$ | async) === false">
            <span>{{ 'catalog.common.baseImageSelectChannel' | translate }}</span>
            <ng-container *ngFor="let item of getBaseChannelsMapping() | keyvalue: channelsOrder;">
              <div class="base-image-channel">
                <div class="base-image-channel-header">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="onSelectBaseImageChannel($event, item.key)"
                                [checked]="getBaseChannelsMapping()[item.key]?.selected"
                                [disabled]="!!form.get(selectedImage.id)?.errors || (isReadOnly$ | async) === true">
                    {{ 'orders.grid.filters.orderSource.'+item.key | translate }}
                  </mat-checkbox>
                  <i *ngIf="getBaseChannelsMapping()[item.key]?.valid !== undefined"
                     [ngClass]="getBaseChannelsMapping()[item.key].valid ? ['tce-icon-circle-check', 'valid-image'] : ['tce-icon-warning', 'invalid-image']"
                     class="tce-icon-checkmark">
                  </i>
                </div>
                <div class="base-image-channel-instructions instructions" *ngIf="getBaseChannelsMapping()[item.key].valid === false">
                  <div *ngFor="let instruction of getBaseChannelsMapping()[item.key].instructions | keyvalue"
                      [ngClass]="{
                        'mat-error':
                        getBaseChannelsMapping()[item.key].errors && getBaseChannelsMapping()[item.key].errors[instruction.key]
                      }"
                      [innerHtml]="instruction.value | translate"
                    ></div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="channels-loading" *ngIf="validationPending$ | async">
             <txp-loading [color]="loadingColor.COLOR" [type]="loadingType.INLINE"></txp-loading>
          </div>
          <txp-button
              class="next-base-image-channel-btn"
              data-qa-label="BaseImageNextButton"
              [style]="buttonStyle.PRIMARY"
              [disabled]="!hasSelectedBaseImageChannels() || isBaseChannelNextDisabled() || (isReadOnly$ | async) === true"
              [loading]="validationPending$ | async"
              (click)="onBaseImageConfigurationStart()">
              {{ 'form.button.next' | translate }}
          </txp-button>
        </div>

        <div class="base-image-channels-navigation"
             [hidden]="isResizing"
             *ngIf="!isBaseImageConfigurationFinished() && isBaseImageConfigurationStarted() && selectedImage.id === imageUploadId.BASE_IMAGE">
          <ng-container *ngFor="let item of getBaseChannelsConfigurationMapping() | keyvalue: channelsOrder; let i = index;">
            <div *ngIf="getBaseChannelsConfigurationMapping()[item.key].current">
              <div class="navigation-header">
                {{ 'orders.grid.filters.orderSource.'+item.key | translate }}
              </div>
              <txp-file-upload data-qa-label="ImageFileUpload"
                               [formControlName]="$any(getBaseChannelsConfigurationMapping()[item.key].controlName)"
                               [accept]="getBaseChannelsConfigurationMapping()[item.key].allowedMimeTypes"
                               [label]="'catalog.common.replaceFile' | translate "
                               [showRemove]="false"
                               [showCrop]="true"
                               [autoResizeChannelId]="getBaseChannelsMapping()[item.key].errors && getBaseChannelsMapping()[item.key].errors['imageDimensions'] ? item.key : undefined"
                               [forceAutoResize]="true"
                               (setIsResizing)="updateIsResizing($event)">
              </txp-file-upload>
              <div class="instructions" *ngIf="getBaseChannelsMapping()[item.key].valid === false">
                <div *ngFor="let instruction of getBaseChannelsMapping()[item.key].instructions | keyvalue"
                    [ngClass]="{
                      'mat-error':
                      getBaseChannelsMapping()[item.key].errors && getBaseChannelsMapping()[item.key].errors[instruction.key]
                    }"
                    [innerHtml]="instruction.value | translate"
                  ></div>
                   <mat-error class="image-error mat-error" *ngIf="getBaseChannelsMapping()[item.key].errors">
                      <span *ngIf="getBaseChannelsMapping()[item.key].errors?.fileSize">{{ 'catalog.common.invalidFileSize' | translate }}</span>
                      <span *ngIf="getBaseChannelsMapping()[item.key].errors?.fileType">{{ 'catalog.common.invalidFileType' | translate }}</span>
                      <span *ngIf="getBaseChannelsMapping()[item.key].errors?.imageDimensions">{{ 'catalog.common.invalidImageDimensions' | translate }}</span>
                  </mat-error>
              </div>
              <div class="navigation-action">
                <txp-button
                    class="navigation-action-left"
                    data-qa-label="BaseImageConfigurationBackButton"
                    [style]="buttonStyle.SECONDARY"
                    (click)="onBaseImageConfigurationNavigation(i, true)">
                  {{ 'form.button.back' | translate }}
                </txp-button>
                <txp-button
                    class="navigation-action-right"
                    data-qa-label="BaseImageConfigurationNextButton"
                    [style]="buttonStyle.PRIMARY"
                    [disabled]="isBaseNavigationNextButtonDisabled(i)"
                    (click)="onBaseImageConfigurationNavigation(i)">
                    {{ 'form.button.next' | translate }}
                </txp-button>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="base-image-finished"
             *ngIf="isBaseImageConfigurationFinished() && selectedImage && selectedImage.id === imageUploadId.BASE_IMAGE">
          {{ 'catalog.common.baseImageFinishedMsg' | translate }}
        </div>

        <div class="loading-container" *ngIf="isResizing">
          <txp-loading [color]="loadingColor.COLOR"></txp-loading>
        </div>
      </ng-container>
    </div>
</div>
